import { useMutation } from "@apollo/react-hooks";
import { Modal, TextField } from "@shopify/polaris";
import React, { useCallback, useReducer } from "react";
import { DENY_AMAZON_IDEA } from "../../../graphql/mutations/amazon-idea";
import { arrInvalid, handleError, reducerFn } from "../../../helper";
import useTimeout from "../../../hooks/useTimeout";
import { ComponentLabelPolaris } from "../../shared/ComponentLabelPolaris";
import { useToastContext } from "../../shared/ToastContext";
import { useAmazonIdeaCtx } from "../context";

export default function AmazonIdeaDeny({ open, onClose, ids, onCompleted }) {
    const { setNotify, toggleToast } = useToastContext();
    const { refetch } = useAmazonIdeaCtx();
    const [state, setState] = useReducer(reducerFn, {
        reason: "",
        error: "",
    });

    const [setDelay] = useTimeout();
    const [denyAmazonIdea, { loading }] = useMutation(DENY_AMAZON_IDEA, {
        onCompleted: () => {
            setNotify({
                msg: "Deny amazon idea successfully",
                err: false,
            });

            onClose();
            onCompleted && onCompleted();
            setDelay(() => {
                refetch && refetch();
            }, 1500);
        },
        onError: (err) => {
            setNotify({ msg: handleError(err?.toString()), err: true });
        },
    });

    const handleSubmit = useCallback(() => {
        if (arrInvalid(ids)) return;
        if (!state.reason) {
            setState({ error: true });
            return;
        }

        toggleToast && toggleToast(true);
        setNotify && setNotify({ msg: null, err: false });

        denyAmazonIdea({
            variables: {
                ids,
                reason: state.reason,
            },
        });
    }, [ids, state.reason]);

    const handleStateChange = React.useCallback((state) => {
        setState({ reason: state, error: !state });
    }, []);

    return (
        <Modal
            open={open}
            onClose={onClose}
            sectioned
            title="Deny Amazon Idea"
            primaryAction={{
                content: "Submit",
                onAction: handleSubmit,
                loading: loading,
            }}
            secondaryActions={[{ content: "Cancel", onAction: onClose }]}
        >
            <div>
                <ComponentLabelPolaris label="Reason" required />
                <TextField
                    id="reason"
                    value={state.reason}
                    onChange={handleStateChange}
                    placeholder="Enter reason"
                    error={state.error ? "Reason is required" : null}
                />
            </div>
        </Modal>
    );
}
